export const DELIVERY_ADDRESSES_SET_LOADING = "DELIVERY_ADDRESSES/SET_LOADING";
export const DELIVERY_ADDRESSES_SET_ERROR = "DELIVERY_ADDRESSES/SET_ERROR";
export const DELIVERY_ADDRESSES_SET_ITEMS = "DELIVERY_ADDRESSES/SET_ITEMS";
export const DELIVERY_ADDRESSES_CLEAR = "DELIVERY_ADDRESSES/CLEAR";
